import React from "react";
import { Link } from "react-router-dom";
import { Container, Overline, Reveal } from "@/components/primitives";
import { posts } from "@/content/insights";
import { useDocumentMeta } from "@/lib/meta";

export default function Insights() {
  useDocumentMeta({
    title: "Insights",
    description: "Owner-sided writing on control, dependency and how law firms actually run.",
    path: "/insights",
  });
  return (
    <div data-testid="insights-page">
      <section className="border-b border-border">
        <Container className="py-20 md:py-28">
          <Reveal>
            <Overline accent>Insights · Owner-sided writing</Overline>
            <h1 className="mt-5 max-w-4xl font-display text-5xl font-semibold leading-[1.0] tracking-tight md:text-7xl">
              Notes on control, dependency and how firms actually run.
            </h1>
            <p className="mt-7 max-w-2xl text-lg leading-relaxed text-muted-foreground">
              Written from inside a working law firm — not a generic SaaS whiteboard. No innovation
              theatre, no empty optimism.
            </p>
          </Reveal>
        </Container>
      </section>

      <section data-testid="insights-list">
        <Container className="border-l border-border">
          {posts.map((p, i) => (
            <Reveal key={p.slug} delay={i * 0.05}>
              <Link
                to={`/insights/${p.slug}`}
                data-testid={`insight-card-${p.slug}`}
                className="group grid grid-cols-1 gap-6 border-b border-r border-border p-8 transition-colors hover:bg-secondary/50 md:grid-cols-12 md:p-12"
              >
                <div className="md:col-span-3">
                  <span className="overline text-accent">{p.category}</span>
                  <div className="mt-3 text-sm text-muted-foreground">{p.readTime}</div>
                </div>
                <div className="md:col-span-9">
                  <h2 className="font-display text-3xl font-medium leading-tight tracking-tight text-foreground transition-colors group-hover:text-accent md:text-4xl">
                    {p.title}
                  </h2>
                  <p className="mt-4 max-w-2xl leading-relaxed text-muted-foreground">{p.dek}</p>
                  <span className="mt-6 inline-flex items-center gap-2 text-sm font-semibold uppercase tracking-[0.12em] text-foreground transition-colors group-hover:text-accent">
                    Read
                    <span className="transition-transform duration-200 group-hover:translate-x-1">→</span>
                  </span>
                </div>
              </Link>
            </Reveal>
          ))}
        </Container>
      </section>
    </div>
  );
}
